import Link from "next/link";

export default function StepItem({number, body, cta, className = ''}) {
    return (
        <div className={`flex items-start gap-5 ${className}`}>
            <div className="w-12 h-12 md:w-24 md:h-24 rounded-full bg-gradient-to-bl from-accent-color to-accent-color/30 inline-flex shrink-0 items-end">
                <span className="text-3xl md:text-7xl font-semibold">{number}</span>
            </div>
            <div className="pt-1 md:pt-6">
                <p className="max-w-[27ch] leading-[1.8]">{body}</p>
                {cta && (
                    <Link href={cta.href}>
                        <a className="text-accent-color underline mouse-hover:no-underline">{cta.label}</a>
                    </Link>
                )}
            </div>
        </div>
    )
}